import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'dashboard-icon',
  templateUrl: './dashboard-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardIconComponent {}
